import { useMutation } from '../';
import { deleteEmailTemplate } from '../mutations';

export function useDeleteEmailTemplate() {
  const { data, isLoading, mutate } = useMutation();

  const run = (variables, onFinish) => {
    mutate(deleteEmailTemplate, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
